import { CardDescription } from "@/types";
import * as S from "./styles";
import { useGlobals } from "@/hooks";
import { useEffect, useState } from "react";

// TODO: ROLLBACK DE

const ContentItem = () => {
  const { cardDescription, setCardDescription } = useGlobals();

  const [currentDescription, setCurrentDescription] = useState(cardDescription);

  useEffect(() => {
    if (cardDescription === CardDescription.DC) return;
    setCardDescription(CardDescription.DC);
  }, [cardDescription]);

  const handleDescription = (description: CardDescription) => {
    setCurrentDescription(description);
    setCardDescription(CardDescription.DC);
  };

  return (
    <S.DirectionControl>
      <S.ButtonDirection
        $active={currentDescription === CardDescription.DE}
        data-test="filter-bar-list-button"
        onClick={() => handleDescription(CardDescription.DE)}
        // onClick={() => setCardDescription(CardDescription.DE)}
      >
        {CardDescription.DE}
      </S.ButtonDirection>

      <S.ButtonDirection
        $active={currentDescription === CardDescription.DC}
        data-test="filter-bar-grid-button"
        onClick={() => handleDescription(CardDescription.DC)}
        // onClick={() => setCardDescription(CardDescription.DC)}
      >
        {CardDescription.DC}
      </S.ButtonDirection>
    </S.DirectionControl>
  );
};

export default ContentItem;
